import $axios from './axios';
import Config from '../config';

export default {

    /**
     * @param {String} url
     * @param {Object} body
     * @return {Promise<Any>}
     */
    async post(url, body = {}) {
        const headers = await this.getHeaders()
        return await $axios.post(url, body, headers)
            .then(({data}) => data)
            .catch(({response}) => this.parseError(response));
    },

    /**
     * @param {String} url
     * @param {Object} body
     * @return {Promise<Any>}
     */
    async patch(url, body = {}) {
        const headers = await this.getHeaders()
        return await $axios.patch(url, body, headers)
            .then(({data}) => data)
            .catch(({response}) => this.parseError(response));
    },

    /**
     * @param {String} url
     * @param {Object} body
     * @return {Promise<Any>}
     */
    async put(url, body) {
        const headers = await this.getHeaders()
        return await $axios.put(url, body, headers)
            .then(({data}) => data)
            .catch(({response}) => this.parseError(response));
    },

    /**
     * @param {String} url
     * @param {Object} parameters
     * @return {Promise<Any>}
     */
    async get(url, parameters = {}) {
        const headers = await this.getHeaders()
        return await $axios.get(url + this.prepareParameters(parameters), headers)
            .then(({data}) => data)
            .catch(({response}) => this.parseError(response));
    },

    /**
     * @param {String} url
     * @param {Object} parameters
     * @return {Promise<Any>}
     */
    async delete(url, parameters = {}) {
        const headers = await this.getHeaders()
        return await $axios.delete(url + this.prepareParameters(parameters), headers)
            .then((response) => response)
            .catch(({response}) => this.parseError(response));
    },

    /**
     * @param {Object} options
     * @return {Promise<Object>}
     */
    async getHeaders(options = {}) {
        const json = options.json || true;
        const headers = {
            'X-Requested-With':            'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*',
        };
        if (json) headers['Content-Type'] = 'application/json';
        return headers;
    },

    /**
     * @param {Object} responseObject
     * @throws {Error}
     */
    parseError(responseObject) {
        if (typeof responseObject === 'object') {
            if (responseObject.hasOwnProperty('status') && [401, 403].indexOf(responseObject.status) !== -1) {
                if (window.location.href.indexOf('/prihlaseni') === -1) {
                    window.location.href = Config.APP_DOMAIN + '/prihlaseni?rt=' + window.location.href;
                }
            } else if (responseObject.hasOwnProperty('error')) {
                const {error} = responseObject;
                if (error.hasOwnProperty('message')) {
                    throw Error(error.message);
                }
            } else if (responseObject.hasOwnProperty('response')) {
                const {response} = responseObject;
                if (typeof response === 'object' && response.hasOwnProperty('data') && response.data.hasOwnProperty('message')) {
                    throw Error(responseObject.response.data.message);
                }
            }
        }
        throw Error('Chyba požadavku');
    },

    /**
     * @param {Object} parameters
     * @return {string}
     */
    prepareParameters(parameters = {}) {
        let result = '';
        if (Object.keys(parameters).length) {
            const buffer = [];
            for (const key in parameters) {
                if (parameters.hasOwnProperty(key)) {
                    if (typeof parameters[key] === 'object') {
                        for (const subKey in parameters[key]) {
                            if (parameters[key].hasOwnProperty(subKey)) {
                                buffer.push(key + '[' + subKey + ']=' + encodeURIComponent(parameters[key][subKey]));
                            }
                        }
                    } else {
                        buffer.push(key + '=' + encodeURIComponent(parameters[key]));
                    }
                }
            }
            result = '?' + buffer.join('&');
        }

        return result;
    }
}
